const outlineVariant = {
    field: {
        _disabled: {
            color: 'text.secondary',
            cursor: 'not-allowed',
            borderColor: 'stroke.light',
            _hover: {
                borderColor: 'stroke.light'
            }
        },
        _focusVisible: {
            borderColor: 'stroke.interactive',
            textStyle: 'mBold',
            boxShadow: 'none',
            _placeholder: {
                fontWeight: 'regular'
            }
        },
        _hover: {
            borderColor: 'stroke.interactive'
        },
        _invalid: {
            borderColor: 'stroke.error',
            color: 'text.error',
            boxShadow: 'none'
        },
        _placeholder: {
            color: 'text.secondary'
        },
        bg: 'fill.white',
        border: '1px solid',
        borderColor: 'stroke.medium',
        borderRadius: '8px',
        fontSize: 'm',
        h: '48px',
        p: 1.5
    }
};
const xsSize = {
    icon: {
        insetEnd: 0
    }
};
export const Select = {
    parts: [
        'field',
        'icon'
    ],
    sizes: {
        xs: xsSize
    },
    variants: {
        outline: outlineVariant
    }
};

//# sourceMappingURL=select.js.map